<template>
<div>
  <div v-for="(question, index) in questions" :key="index"
       class="w-100 mt-4 mb-3" :id="question.id">
    <div class="font-size-18">
      <strong>
        {{index+1}}. {{question.question}}
      </strong>
    </div>
    <div class="w-100 mt-4">
      <div v-for="(answer, aIndex) in question.answers" :key="aIndex" class="mt-3">
        <b-form-group>
          <b-form-radio
              v-model="question.answer"
              class="mb-3"
              :value="answer.id"
              plain
              @change="selectAnswer"
          ><span class="font-size-16">{{answer.answer}}</span></b-form-radio>
        </b-form-group>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Questions",
  props:{
    questions: {
      required: true,
      type: Array,
    },
    goToId: {
      required: false,
    },
  },
  data() {
    return {
      selected: 'first',
      options: [
        { text: ' going/ going', value: 'first' },
        { text: ' is going to/ is going to', value: 'second' },
        { text: ' is/ is', value: 'third' },
        { text: ' will/ will', value: 'forth' }
      ]
    }
  },
  methods: {
    selectAnswer() {
      this.$emit('answerSelected')
    }
  },
  watch: {
    goToId: {
      immediate: true,
      handler(val) {
        if(val) {
          const el = document.getElementById(val);
          el.scrollIntoView({behavior: "smooth"});
        }
      }
    }
  }
}
</script>

<style scoped>
.text{
  font-weight: bold;
}
.btn{
  width: 20%;
  margin-top: 20px;
margin-left: 580px;
}
.bx{
  margin-left: 20px;
}
</style>
